import { CHARTER_THEME } from "../controleTheme";

export function PointComment({ title, value, pointColor, onChange, disabled = false }) {
    const { inputStyle } = CHARTER_THEME;
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            background: "#f8fafc",
            border: `1px solid ${pointColor}`,
        }}>
            <label style={{ display: "grid", gap: "6px" }}>
                <span style={{ color: "#0f172a", fontSize: "13px", fontWeight: 900 }}>
                    {title}
                </span>
                <textarea
                    style={{
                        ...inputStyle,
                        width: "100%",
                        minHeight: "82px",
                        resize: "vertical",
                        lineHeight: 1.45,
                        background: disabled ? "#f1f5f9" : "white",
                        cursor: disabled ? "not-allowed" : "text",
                    }}
                    value={value}
                    disabled={disabled}
                    onChange={event => onChange(event.target.value)}
                    placeholder="Commentaire"
                />
            </label>
        </div>
    );
}
